module.exports = __webpack_public_path__ + "static/media/sign_in_french.5b2f4b55.jpg";